<template>
  <div id="v-widget">
    <v-card>
      <v-progress-linear
        v-if="progress"
        color="primary"
        indeterminate
      />
      <v-toolbar
        v-if="enableHeader"
        color="transparent"
        flat
        dense
        tabs
        card
      >
        <v-toolbar-title>
          <h4>{{ title }}</h4>
        </v-toolbar-title>

        <v-spacer />

        <slot name="widget-header-action" />
      </v-toolbar>

      <v-divider v-if="enableHeader" />

      <v-card-text v-if="!hideContent">
        <slot name="widget-content" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'VWidget',
  props: {
    title: {
      default: '',
      type: String
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    contentBg: {
      type: String,
      default: 'white'
    },
    progress: {
      type: Boolean,
      default: false
    },
    hideContent: {
      type: Boolean,
      default: false
    }
  }
}
</script>
